import { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './File.module.css';
import { Button } from '../button';
import { InputLabel } from '../input-label';

interface FileProps {
  onChange?: (input: TypeAny) => TypeAny;
  multiple?: boolean;
  required?: boolean;
  label?: string;
  name: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const File = forwardRef<HTMLInputElement, FileProps>(
  ({ multiple, required, onChange, label, name, disabled, isLoading }, ref) => {
    const { t } = useTranslation();

    const inputId = `file-${name}`;

    return (
      <label className={styles.file} htmlFor={inputId}>
        {label && <InputLabel required={required} label={label} />}

        <input
          className={styles.fileElement}
          data-testid="fileInput"
          onChange={onChange}
          multiple={multiple}
          id={inputId}
          name={name}
          type="file"
          ref={ref}
          disabled={disabled || isLoading}
        />

        <div className={styles.fileCta}>
          <div className={styles.fileCtaButton}>
            <Button theme="cta" disabled={disabled} isLoading={isLoading}>
              {t('file.cta')}
            </Button>
          </div>
        </div>
      </label>
    );
  }
);

File.displayName = 'File';

export { File };
